module.exports = __webpack_public_path__ + "static/media/app-store.0753fb84.svg";